import { type ComponentType } from 'react'
import { Observable, observe, Scope } from 'wdc-cube'

export enum EnumModuleNames {
    THE_CONNECTION = 'theConnection',
    THE_CONSUMER_MARKET = 'theConsumerMarket',
    THE_ACTING = 'theActing',
    MERCADO_VET = 'mercadoVet',
    ANALISE_DESEMPENHO = 'analiseDesempenho'
}

export type ModuleCard = {
    icon: ComponentType
    moduleName: EnumModuleNames
    name: string
    description: string
    bullets: string[]
    active: boolean
}

@Observable
export class HeaderScope extends Scope {}

@Observable
export class OverviewScope extends Scope {
    readonly header = new HeaderScope()

    @observe() modules = [] as ModuleCard[]

    onOpenModule = Scope.ASYNC_ACTION_ONE<EnumModuleNames>()
}
